import { Continent } from "@/types/continent";

const CONTINENTS: Continent[] = [
  "africa",
  "europe",
  "asia",
  "north-america",
  "latin-america",
  "south-america",
  "oceania",
];

export function getContinentCounts(
  tours: { continent?: string }[],
): Record<Continent, number> {
  return tours.reduce(
    (acc, tour) => {
      const key = tour.continent;
      if (key && CONTINENTS.includes(key as Continent)) {
        acc[key as Continent]++;
      }
      return acc;
    },
    {
      africa: 0,
      europe: 0,
      asia: 0,
      "north-america": 0,
      "latin-america": 0,
      "south-america": 0,
      oceania: 0,
    },
  );
}

export function isValidContinent(value?: string): value is Continent {
  return Boolean(value && CONTINENTS.includes(value as Continent));
}

export function getInitialContinents(
  continentFromUrl: string | null,
): Continent[] {
  return continentFromUrl && isValidContinent(continentFromUrl)
    ? [continentFromUrl]
    : [];
}
